<header #headerRef class="headerFixed">
  <div class="navPrincipal">
    <div class="contLogo">
      <img
        src="https://res.cloudinary.com/dtyvd3fim/image/upload/v1764678577/ChatGPT_Image_12_nov_2025_17_33_14_1_hj26hs.png"
        alt="TripGo" />
      <a href="#" (click)="goHome($event)">TripGO</a>
    </div>

    <div class="rightActions">

      @if (isEmpresaPage) {
        <div class="OpLaterales">
          <a href="#" (click)="confirmLogout(); $event.preventDefault()">Salir</a>
           <button type="button" class="darkToggleMobile" (click)="darkMode.toggle(); closeMenu()">
          <span class="darkToggle__track" [class.darkToggle__track--on]="darkMode.isDark()">
            <span class="darkToggle__thumb">
              <svg *ngIf="!darkMode.isDark()" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">
                <circle cx="12" cy="12" r="5"/>
                <line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/>
                <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
                <line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/>
                <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
              </svg>
              <svg *ngIf="darkMode.isDark()" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">
                <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
              </svg>
            </span>
          </span>
          {{ darkMode.isDark() ? '' : '' }}
        </button>
        </div>
      } @else {

        @if (isLoggedIn) {
          <div class="itWrap" (click)="$event.stopPropagation()">
            <button type="button" class="itHeaderBtn iconOnly" (click)="toggleItinerario()" aria-label="Mi itinerario">
              <svg xmlns="http://www.w3.org/2000/svg" class="itIcon" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M9 7V5a3 3 0 0 1 6 0v2" />
                <rect x="3" y="7" width="18" height="13" rx="3" />
                <path d="M3 13h18" />
                <circle cx="12" cy="13" r="1.2" fill="currentColor" stroke="none" />
              </svg>
              @if (itinerario.count > 0) {
                <span class="itBadge">{{ itinerario.count }}</span>
              }
            </button>

            @if (itinerarioOpen) {
              <div class="itPopover" (click)="$event.stopPropagation()">
                <div class="itPop__header">
                  <div class="itPop__headerLeft">
                    <div class="itPop__icon">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M9 7V5a3 3 0 0 1 6 0v2"/><rect x="3" y="7" width="18" height="13" rx="3"/><path d="M3 13h18"/>
                      </svg>
                    </div>
                    <div>
                      <div class="itPop__title">Mi itinerario</div>
                      <div class="itPop__subtitle" *ngIf="itinerario.count > 0">
                        {{ itinerario.count }} lugar{{ itinerario.count !== 1 ? 'es' : '' }} · {{ getTotalGlobal() | number:'1.0-0' }} COP
                      </div>
                      <div class="itPop__subtitle" *ngIf="itinerario.count === 0">Aún vacío</div>
                    </div>
                  </div>
                  <button class="itPop__close" type="button" (click)="closeItinerario()">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>
                  </button>
                </div>
                <div class="itPop__body">
                  <ng-container *ngIf="(itinerario.items$ | async) as items">
                    <div class="itPop__empty" *ngIf="items.length === 0">
                      <div class="itPop__emptyIcon"><i class="fas fa-map-marker-alt"></i></div>
                      <div class="itPop__emptyTitle">Sin lugares aún</div>
                      <div class="itPop__emptySub">Explora y agrega destinos a tu itinerario</div>
                    </div>
                    <div class="itPop__list" *ngIf="items.length > 0">
                      <div class="itPop__item" *ngFor="let it of items; let i = index">
                        <div class="itPop__num">{{ i + 1 }}</div>
                        <div class="itPop__imgWrap">
                          <img *ngIf="it.imagenUrl" [src]="it.imagenUrl" class="itPop__img" [alt]="it.nombre" />
                          <div *ngIf="!it.imagenUrl" class="itPop__imgPlaceholder"><i class="fas fa-map-marker-alt"></i></div>
                        </div>
                        <div class="itPop__info">
                          <div class="itPop__name">{{ it.nombre }}</div>
                          <div class="itPop__addr" *ngIf="it.direccion">{{ it.direccion }}</div>
                          <div class="itPop__productos" *ngIf="it.productos?.length">
                            <div class="itPop__prodItem" *ngFor="let p of it.productos">
                              <span class="itPop__prodDot"></span>
                              <span class="itPop__prodNombre">{{ p.nombre }}</span>
                              <span class="itPop__prodCant" *ngIf="p.cantidad && p.cantidad > 1">×{{ p.cantidad }}</span>
                              <span class="itPop__prodPrecio">${{ p.precio * (p.cantidad ?? 1) | number:'1.0-0' }}</span>
                            </div>
                          </div>
                          <div class="itPop__noProd" *ngIf="!it.productos?.length">
                            <span>Sin productos seleccionados</span>
                          </div>
                          <div class="itPop__itemFooter">
                            <div class="itPop__subtotal" *ngIf="it.productos?.length">
                              <span class="itPop__subtotalLbl">Subtotal</span>
                              <span class="itPop__subtotalVal">${{ getSubtotal(it) | number:'1.0-0' }}</span>
                            </div>
                          </div>
                        </div>
                        <button class="itPop__remove" type="button" (click)="confirmarQuitarItem(it.id)" title="Quitar lugar">
                          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>
                        </button>
                      </div>
                    </div>
                  </ng-container>
                </div>
                <div class="itPop__totalBar" *ngIf="itinerario.count > 0">
                  <div class="itPop__totalRow">
                    <div class="itPop__totalLeft">
                      <span class="itPop__totalLabel">Total estimado</span>
                      <span class="itPop__totalMeta">
                        {{ itinerario.count }} lugar{{ itinerario.count !== 1 ? 'es' : '' }}
                        · {{ getTotalPersonas() }} persona{{ getTotalPersonas() !== 1 ? 's' : '' }}
                      </span>
                    </div>
                    <div class="itPop__totalRight">
                      <span class="itPop__totalCOP">${{ getTotalGlobal() | number:'1.0-0' }}</span>
                      <span class="itPop__totalCOPLabel">COP</span>
                    </div>
                  </div>
                </div>
                <div class="itPop__footer">
                  <button type="button" class="itPop__btnClear" (click)="confirmarLimpiar()" [disabled]="itinerario.count === 0">
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>
                    Limpiar
                  </button>
                  <button type="button" class="itPop__btnConfirm" [disabled]="itinerario.count === 0 || enviandoEmail" (click)="confirmarItinerario()">
                    @if (enviandoEmail) {
                      <span class="itPop__spinner"></span> Enviando...
                    } @else {
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 2L11 13"/><path d="M22 2L15 22l-4-9-9-4 20-7z"/></svg>
                      Confirmar
                    }
                  </button>
                </div>
              </div>
            }
          </div>
        }

        <div class="OpLaterales">
          @if (!isLoggedIn) {
            <a routerLink="/login" class="btnLogin desktopOnly">{{ 'AUTH.LOGIN_TITLE' | translate }}</a>
            <a routerLink="/register" class="btnRegister desktopOnly">{{ 'AUTH.REGISTER_TITLE' | translate }}</a>
            <div class="navControls desktopOnly">
              <button type="button" class="langBtn" (click)="lang.toggleLanguage()">
                {{ lang.getCurrentLanguage() === 'es' ? 'EN' : 'ES' }}
              </button>
              <button type="button" class="darkToggle" (click)="darkMode.toggle()"
                [attr.aria-label]="darkMode.isDark() ? 'Activar modo claro' : 'Activar modo oscuro'">
                <span class="darkToggle__track" [class.darkToggle__track--on]="darkMode.isDark()">
                  <span class="darkToggle__thumb">
                    <svg *ngIf="!darkMode.isDark()" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">
                      <circle cx="12" cy="12" r="5"/>
                      <line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/>
                      <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
                      <line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/>
                      <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
                    </svg>
                    <svg *ngIf="darkMode.isDark()" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">
                      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
                    </svg>
                  </span>
                </span>
              </button>
            </div>
          } @else {
            <a routerLink="/editar-cuenta" class="topActionLink desktopOnly">Perfil</a>
            <a href="#" class="topActionLink" (click)="confirmLogout(); $event.preventDefault()">Salir</a>
            <div class="navControls">
              <button type="button" class="langBtn" (click)="lang.toggleLanguage()">
                {{ lang.getCurrentLanguage() === 'es' ? 'EN' : 'ES' }}
              </button>
              <button type="button" class="darkToggle" (click)="darkMode.toggle()"
                [attr.aria-label]="darkMode.isDark() ? 'Activar modo claro' : 'Activar modo oscuro'">
                <span class="darkToggle__track" [class.darkToggle__track--on]="darkMode.isDark()">
                  <span class="darkToggle__thumb">
                    <svg *ngIf="!darkMode.isDark()" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">
                      <circle cx="12" cy="12" r="5"/>
                      <line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/>
                      <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
                      <line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/>
                      <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
                    </svg>
                    <svg *ngIf="darkMode.isDark()" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">
                      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
                    </svg>
                  </span>
                </span>
              </button>
            </div>
          }
        </div>

        @if (!isLoggedIn) {
          <button class="hamburgerBtn" type="button" (click)="toggleMenu()">☰</button>
        }

      }

    </div>
  </div>

  @if (!isEmpresaPage) {
    <div class="nav-bar">
      @if (!isLoggedIn) {
        <a href="/#Nosotros">{{ 'NAV.ABOUT_US_TITLE' | translate }}</a>
        <a href="/#comoFunciona">{{ 'NAV.HOW_WORKS_TITLE' | translate }}</a>
        <a routerLink="/prices">{{ 'NAV.PRICES' | translate }}</a>
        <a routerLink="/contact">{{ 'NAV.CONTACT' | translate }}</a>
      } @else {
        <a routerLink="/principal">{{ 'NAV.HOME' | translate }}</a>
        <a routerLink="/recomendaciones">{{ 'NAV.SUGGEST' | translate }}</a>
        <a routerLink="/soporte">{{ 'NAV.SUPPORT' | translate }}</a>
      }
    </div>
  }

  @if (!isEmpresaPage && menuOpen) {
    <div class="menuOverlay" (click)="closeMenu()"></div>
    <aside class="sideMenu" (click)="$event.stopPropagation()">
      <div class="sideMenu__top">
        <span class="sideMenu__title">Menú</span>
        <button class="sideMenu__close" type="button" (click)="closeMenu()">✕</button>
      </div>
      <nav class="sideMenu__links">
        @if (!isLoggedIn) {
          <a routerLink="/login" (click)="closeMenu()">{{ 'AUTH.LOGIN_TITLE' | translate }}</a>
          <a routerLink="/register" (click)="closeMenu()">Registrarse</a>
          <a href="/#Nosotros" (click)="closeMenu()">¿Quienes somos?</a>
          <a href="/#comoFunciona" (click)="closeMenu()">Como funciona</a>
          <a routerLink="/prices" (click)="closeMenu()">Algunos planes</a>
          <a routerLink="/contact" (click)="closeMenu()">Quieres ser parte de nosotros?</a>
        } @else {
          <a routerLink="/principal" (click)="closeMenu()">Lugares</a>
          <a routerLink="/recomendaciones" (click)="closeMenu()">Recomendaciones</a>
          <a routerLink="/soporte" (click)="closeMenu()">Soporte</a>
          <a routerLink="/editar-cuenta" (click)="closeMenu()">Perfil</a>
          <a href="#" (click)="confirmLogout(); $event.preventDefault()">Salir</a>
        }
        <button type="button" class="langBtnMobile" (click)="lang.toggleLanguage(); closeMenu()">
          Cambiar a {{ lang.getCurrentLanguage() === 'es' ? 'Ingles' : 'Español' }}
        </button>
        <button type="button" class="darkToggleMobile" (click)="darkMode.toggle(); closeMenu()">
          <span class="darkToggle__track" [class.darkToggle__track--on]="darkMode.isDark()">
            <span class="darkToggle__thumb">
              <svg *ngIf="!darkMode.isDark()" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">
                <circle cx="12" cy="12" r="5"/>
                <line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/>
                <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
                <line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/>
                <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
              </svg>
              <svg *ngIf="darkMode.isDark()" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">
                <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
              </svg>
            </span>
          </span>
          {{ darkMode.isDark() ? 'Modo claro' : 'Modo oscuro' }}
        </button>
      </nav>
    </aside>
  }

  @if (emailEnviado) {
    <div class="overlayProcesando overlayProcesando--ok">
      <div class="overlayCard overlayCard--ok">
        <div class="overlayCheck">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="20 6 9 17 4 12"/>
          </svg>
        </div>
        <h2>¡Itinerario enviado!</h2>
        <p>Revisá tu correo, te enviamos el resumen completo de tu aventura en el Quindío.</p>
        <div class="overlaySteps">
          <span class="step active">Preparando</span>
          <span class="dot"></span>
          <span class="step active">Enviando</span>
          <span class="dot"></span>
          <span class="step active">Confirmado ✓</span>
        </div>
        <button class="overlayOkBtn" type="button" (click)="emailEnviado = false; closeItinerario()">
          Continuar explorando
        </button>
        <div class="overlayBrand">TRIPGO · conectando experiencias</div>
      </div>
    </div>
  }

 <!-- BOTTOM NAV MÓVIL -->
@if (!isEmpresaPage) {
  <nav class="bottomNav">

    <a routerLink="/principal" routerLinkActive="bottomNav__item--active" class="bottomNav__item">
      <div class="bottomNav__iconWrap">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
          <polyline points="9 22 9 12 15 12 15 22"/>
        </svg>
      </div>
      <span>Inicio</span>
    </a>

    <a 
      [routerLink]="authService.isLoggedIn() ? '/recomendaciones' : null"
      routerLinkActive="bottomNav__item--active"
      class="bottomNav__item"
      (click)="goToProtected($event, '/recomendaciones')">
      <div class="bottomNav__iconWrap">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
        </svg>
      </div>
      <span>Recomienda...</span>
    </a>

    <button
      type="button"
      class="bottomNav__item"
      (click)="toggleItinerario($event)">
      <div class="bottomNav__iconWrap" style="position:relative;">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
             stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M9 7V5a3 3 0 0 1 6 0v2"/>
          <rect x="3" y="7" width="18" height="13" rx="3"/>
          <path d="M3 13h18"/>
        </svg>
        @if (itinerario.count > 0) {
          <span class="bottomNav__badge">{{ itinerario.count }}</span>
        }
      </div>
      <span>Itinerario</span>
    </button>

    <a
      [routerLink]="authService.isLoggedIn() ? '/editar-cuenta' : null"
      routerLinkActive="bottomNav__item--active"
      class="bottomNav__item"
      (click)="goToProtected($event, '/editar-cuenta')">
      <div class="bottomNav__iconWrap">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
             stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
          <circle cx="12" cy="7" r="4"/>
        </svg>
      </div>
      <span>Perfil</span>
    </a>

    <a
      [routerLink]="authService.isLoggedIn() ? '/soporte' : null"
      routerLinkActive="bottomNav__item--active"
      class="bottomNav__item"
      (click)="goToProtected($event, '/soporte')">
      <div class="bottomNav__iconWrap">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
             stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"/>
          <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
          <line x1="12" y1="17" x2="12.01" y2="17"/>
        </svg>
      </div>
      <span>Soporte</span>
    </a>

  </nav>
}
  <!-- ITINERARIO MÓVIL -->
  @if (itinerarioOpen && isLoggedIn) {
    <div class="itBackdropMobile" (click)="closeItinerario()"></div>
    <div class="itPopoverMobile" (click)="$event.stopPropagation()">
      <div class="itPop__header">
        <div class="itPop__headerLeft">
          <div class="itPop__icon">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M9 7V5a3 3 0 0 1 6 0v2"/><rect x="3" y="7" width="18" height="13" rx="3"/><path d="M3 13h18"/>
            </svg>
          </div>
          <div>
            <div class="itPop__title">Mi itinerario</div>
            <div class="itPop__subtitle" *ngIf="itinerario.count > 0">
              {{ itinerario.count }} lugar{{ itinerario.count !== 1 ? 'es' : '' }} · {{ getTotalGlobal() | number:'1.0-0' }} COP
            </div>
            <div class="itPop__subtitle" *ngIf="itinerario.count === 0">Aún vacío</div>
          </div>
        </div>
        <button class="itPop__close" type="button" (click)="closeItinerario()">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>
        </button>
      </div>
      <div class="itPop__body">
        <ng-container *ngIf="(itinerario.items$ | async) as items">
          <div class="itPop__empty" *ngIf="items.length === 0">
            <div class="itPop__emptyIcon">🗺️</div>
            <div class="itPop__emptyTitle">Sin lugares aún</div>
            <div class="itPop__emptySub">Explora y agrega destinos a tu itinerario</div>
          </div>
          <div class="itPop__list" *ngIf="items.length > 0">
            <div class="itPop__item" *ngFor="let it of items; let i = index">
              <div class="itPop__num">{{ i + 1 }}</div>
              <div class="itPop__imgWrap">
                <img *ngIf="it.imagenUrl" [src]="it.imagenUrl" class="itPop__img" [alt]="it.nombre" />
                <div *ngIf="!it.imagenUrl" class="itPop__imgPlaceholder">📍</div>
              </div>
              <div class="itPop__info">
                <div class="itPop__name">{{ it.nombre }}</div>
                <div class="itPop__addr" *ngIf="it.direccion">{{ it.direccion }}</div>
                <div class="itPop__productos" *ngIf="it.productos?.length">
                  <div class="itPop__prodItem" *ngFor="let p of it.productos">
                    <span class="itPop__prodDot"></span>
                    <span class="itPop__prodNombre">{{ p.nombre }}</span>
                    <span class="itPop__prodCant" *ngIf="p.cantidad && p.cantidad > 1">×{{ p.cantidad }}</span>
                    <span class="itPop__prodPrecio">${{ p.precio * (p.cantidad ?? 1) | number:'1.0-0' }}</span>
                  </div>
                </div>
                <div class="itPop__noProd" *ngIf="!it.productos?.length">Sin productos seleccionados</div>
                <div class="itPop__itemFooter">
                  <div class="itPop__subtotal" *ngIf="it.productos?.length">
                    <span class="itPop__subtotalLbl">Subtotal</span>
                    <span class="itPop__subtotalVal">${{ getSubtotal(it) | number:'1.0-0' }}</span>
                  </div>
                </div>
              </div>
              <button class="itPop__remove" type="button" (click)="confirmarQuitarItem(it.id)" title="Quitar lugar">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>
              </button>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="itPop__totalBar" *ngIf="itinerario.count > 0">
        <div class="itPop__totalRow">
          <div class="itPop__totalLeft">
            <span class="itPop__totalLabel">Total estimado</span>
            <span class="itPop__totalMeta">{{ itinerario.count }} lugar{{ itinerario.count !== 1 ? 'es' : '' }} · {{ getTotalPersonas() }} persona{{ getTotalPersonas() !== 1 ? 's' : '' }}</span>
          </div>
          <div class="itPop__totalRight">
            <span class="itPop__totalCOP">${{ getTotalGlobal() | number:'1.0-0' }}</span>
            <span class="itPop__totalCOPLabel">COP</span>
          </div>
        </div>
      </div>
      <div class="itPop__footer">
        <button type="button" class="itPop__btnClear" (click)="confirmarLimpiar()" [disabled]="itinerario.count === 0">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>
          Limpiar
        </button>
        <button type="button" class="itPop__btnConfirm" [disabled]="itinerario.count === 0 || enviandoEmail" (click)="confirmarItinerario()">
          @if (enviandoEmail) {
            <span class="itPop__spinner"></span> Enviando...
          } @else {
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 2L11 13"/><path d="M22 2L15 22l-4-9-9-4 20-7z"/></svg>
            Confirmar
          }
        </button>
      </div>
    </div>
  }

</header>
<app-confirm-dialog></app-confirm-dialog>